export const TYPES = {
  SELECT_ALL_REQUEST_SUCCESS: "request/SELECT_ALL_REQUEST_SUCCESS",
  GET_COUNT_REQUEST_SUCCESS: "request/GET_COUNT_REQUEST_SUCCESS",
};
